import {LobbyImage} from '@colonist/types'
import {TranslationObject} from '@colonist/i18n'
import {GameTypeEnum, UIMMatchmakingController} from './UIMMatchmakingController'
import {UIMMatchmakingSearchingView} from './UIMMatchmakingSearchingView'

export class UIMMatchmakingSearchingCnKView extends UIMMatchmakingSearchingView {
    constructor(matchmakingController: UIMMatchmakingController, isRanked: boolean) {
        const loadingText: TranslationObject = {key: 'strings:homePage.matchmakingPopup.searchingForOpponents'}
        const citiesAndKnightsRanked: TranslationObject = {key: 'strings:homePage.matchmakingPopup.rankedCitiesAndKnights'}
        const citiesAndKnightsUnranked: TranslationObject = {key: 'strings:homePage.unranked.citiesAndKnights'}
        const title = isRanked ? citiesAndKnightsRanked : citiesAndKnightsUnranked
        const imageSrc = LobbyImage.GameModeCnK

        super(matchmakingController, title, imageSrc, loadingText, isRanked, GameTypeEnum.CitiesAndKnights4P)
    }

    addTitle() {
        super.addTitle()
        this.setTimeElapsedCounter()
    }
}
